import { useMutation } from '@tanstack/react-query';

import { useSnackbar } from 'notistack';

import {
  IncidentClient,
  IncidentCreateResponse,
  IncidentEventReportMutationRequest,
  ProblemDetails,
} from '../../clients';

import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const incidentClient = new IncidentClient(apiBaseUrl);

function useCreateNewIncident() {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation<IncidentCreateResponse, ProblemDetails, IncidentEventReportMutationRequest[], unknown>({
    mutationKey: [queryKeys.Incident.CreateNew],
    mutationFn: (request: IncidentEventReportMutationRequest[]) => incidentClient.createNew(request),
    onError: (error) => {
      const statusMessage = error.status === 409
        ? 'Data has changed on the server, please refresh the page and try again.'
        : 'An unexpected error has occurred.';

      enqueueSnackbar(statusMessage, { variant: 'error', persist: true });
    },
  });
}

export default useCreateNewIncident;
